import styled from 'styled-components'

export const DropdownMenu = styled.div`
  width: 120px;
  max-height: 200px;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  gap: 4px;

  padding: 4px;
  box-sizing: border-box;

  border-radius: 8px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  background: var(--background-elevation-overlay, #fff);
`

export const DropdownItem = styled.div`
  align-items: center;
  display: flex;

  padding: 8px 12px;
  box-sizing: border-box;
  cursor: pointer;

  color: var(--Foreground-Neutral, var(--Foreground-Neutral, #14171f));

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  width: 100%;

  border-radius: 4px;

  background: var(--background-elevation-base, #fff);

  cursor: pointer;

  :hover {
    background: var(--background-elevation-base, #f3f4f6);
  }
`

export const IconImg = styled.img`
  padding-right: 8px;
`

export const ExportIconImg = styled.img`
  padding-right: 2px;
`
